import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppConfirmDialog from '@/components/common/AppConfirmDialog.vue'
import { resolveAppConfirm, useAppConfirmState } from '@/composables/useAppConfirm'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppConfirmHost',
  setup(__props) {

const state = useAppConfirmState()

const onConfirm = () => resolveAppConfirm(true)
const onCancel = () => resolveAppConfirm(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppConfirmDialog, {
    "model-value": _unref(state).open,
    title: _unref(state).title,
    message: _unref(state).message,
    "confirm-text": _unref(state).confirmText,
    "cancel-text": _unref(state).cancelText,
    "alert-only": _unref(state).alertOnly,
    onConfirm: onConfirm,
    onCancel: onCancel
  }, null, 8, ["model-value", "title", "message", "confirm-text", "cancel-text", "alert-only"]))
}
}

})